export enum Permission {
  EmergingBrandsPortal = 'emerging_brands_portal.modify',
}
